import React from 'react';
import ServicesManager from '../../components/services/ServicesManager';
import { useTenant } from '../../tenancy/TenantContext';

const ServicesScreen: React.FC = () => {
    const { tenantId } = useTenant();
    return <ServicesManager tenantId={tenantId} />;
};

export default ServicesScreen;
